module.exports = __webpack_public_path__ + "static/btweb-windows-screen@2x-42985ea4c56ea5ffae56f4342da9d3c4.png";